var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentAfterHours(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 0,
    cx: 51,
    cy: 51,
    rx: 51,
    ry: 51,
    transform: "rotate(-180 51 51)",
    fill: "url(#paint0_linear_13305_55979)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 0,
    opacity: 0.8,
    cx: 50.9998,
    cy: 35.5814,
    rx: 18.9767,
    ry: 18.9767,
    transform: "rotate(-180 50.9998 35.5814)",
    fill: "url(#paint1_linear_13305_55979)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 32C27 20.9543 37.1929 11.5 51 11.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 29C73 19.6112 63.6565 11.5 51 11.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30C73 39.3888 63.6565 47 51 47",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3089 83.495C80.9544 94.7983 66.8181 102 50.9998 102C35.1814 102 21.0449 94.7982 11.6904 83.4947C19.4139 69.7638 34.1236 60.4884 50.9996 60.4884C67.8758 60.4884 82.5855 69.7639 90.3089 83.495Z",
    fill: "url(#paint2_linear_13305_55979)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0,
    x: 65,
    y: 65,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#4F6291"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.5 95.375C75.4289 95.375 73.75 93.6961 73.75 91.625L73.75 78.9688C73.75 76.8977 75.4289 75.2188 77.5 75.2188L92.5 75.2188C94.5711 75.2188 96.25 76.8977 96.25 78.9688L96.25 82.9712L96.25 88.0455L96.25 89.8778L96.25 91.625C96.25 93.6961 94.5711 95.375 92.5 95.375L77.5 95.375Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 94.4375C75.9467 94.4375 74.6875 93.1783 74.6875 91.625L74.6875 78.9688C74.6875 77.4155 75.9467 76.1563 77.5 76.1563L92.5 76.1563C94.0533 76.1563 95.3125 77.4155 95.3125 78.9688L95.3125 82.9712L95.3125 88.0455L95.3125 89.8778L95.3125 91.625C95.3125 93.1783 94.0533 94.4375 92.5 94.4375L77.5 94.4375Z",
    stroke: "white",
    strokeWidth: 1.875
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.25 73.8125L81.25 79.4375M88.75 73.8125V79.4375",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.375 83.1875H75.625",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 46,
    r: 5,
    fill: "white",
    strokeWidth: 0
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13305_55979",
    x1: 82,
    y1: 87.5,
    x2: -54.5,
    y2: -61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13305_55979",
    x1: 64.9996,
    y1: 52.6627,
    x2: 36.4996,
    y2: 7.66273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13305_55979",
    x1: 14,
    y1: 35,
    x2: 53,
    y2: 105.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentAfterHours);
export default __webpack_public_path__ + "static/media/agent-after-hours.3ac48bc69ff302ef42653d4c67e675d2.svg";
export { ForwardRef as ReactComponent };